export const ActionTypes = {
  QUESTION_TABLE_CELL_CHANGE: "QUESTION_TABLE_CELL_CHANGE",
  QUESTION_TABLE_SUBMIT: "QUESTION_TABLE_SUBMIT",
  QUESTION_TABLE_SHOW_HINT: "QUESTION_TABLE_SHOW_HINT",
  QUESTION_TABLE_SHOW_NEXT_HINT: "QUESTION_TABLE_SHOW_NEXT_HINT",
  QUESTION_TABLE_OVERRIDE_CELL_DATA: "QUESTION_TABLE_OVERRIDE_CELL_DATA",
};

export function questionTableCellChange(payload) {
  return {
    type: "QUESTION_TABLE_CELL_CHANGE",
    payload,
  };
}

export function questionTableSubmit(payload) {
  return {
    type: "QUESTION_TABLE_SUBMIT",
    payload,
  };
}

export function questionTableShowHint(payload) {
  return {
    type: "QUESTION_TABLE_SHOW_HINT",
    payload,
  };
}

export function questionTableShowNextHint(payload) {
  return {
    type: "QUESTION_TABLE_SHOW_NEXT_HINT",
    payload,
  };
}

export function questionTableOverrideCellData(payload) {
  return {
    type: "QUESTION_TABLE_OVERRIDE_CELL_DATA",
    payload,
  };
}
